import { GameCommunicationConnectionObserver } from './GameCommunicationConnectionObserver';
import { GameCommunicationBetsOpenProcessor } from './processors/GameCommunicationBetsOpenProcessor';
import { GameCommunicationGameResultProcessor } from './processors/GameCommunicationGameResultProcessor';
import { GameCommunicationStartDealingProcessor } from './processors/GameCommunicationStartDealingProcessor';
import { GameCommunicationMegaWinProcessor } from './processors/GameCommunicationMegaWinProcessor';
import { GameCommunicationRestoreDealingProcessor } from './processors/GameCommunicationRestoreDealingProcessor';
import { GameCommunicationGameCancelledProcessor } from './processors/GameCommunicationCanceledProcessor';
import { GameInstantBetsSender } from './senders/GameInstantBetSender';
import { MwCommunicationTimerProcessor } from './processors/MwCommunicationTimerProcessor';
import { GameCommunicationBetsStatsProcessor } from './processors/GameCommunicationBetsStatsProcessor';
import { GameCommunicationPlayerWinProcessor } from './processors/GameCommunicationPlayerWinProcessor';

export const MWGameCommunicationControllerConfig = {
  processors: [
    new GameCommunicationBetsOpenProcessor(),
    new GameCommunicationGameResultProcessor(),
    new GameCommunicationStartDealingProcessor(),
    new GameCommunicationMegaWinProcessor(),
    new GameCommunicationRestoreDealingProcessor(),
    new GameCommunicationGameCancelledProcessor(),
    new MwCommunicationTimerProcessor(),
    new GameCommunicationBetsStatsProcessor(),
    new GameCommunicationPlayerWinProcessor(),
  ],
  senders: [new GameInstantBetsSender()],
  connectionObserver: new GameCommunicationConnectionObserver(),
};
